import { useContext } from "react";
import { GlobalContext } from "../../../../global/context/Provider";
import { PortalContext } from "../../../context/Provider";
import "./VersionApp.css";
import { hideModal } from "_+_Portal/context/Actions/modal/modal";
import { Capacitor } from "@capacitor/core";

const VersionApp = ({ dissmiss }) => {
  const { textosState, modalDispatch } = useContext(PortalContext);
  const { versionPublicadaState, configState } = useContext(GlobalContext);

  let esCritico = versionPublicadaState.versionPublicada.data.critico;

  const actualizarApp = () => {
    const platform = Capacitor.getPlatform();

    if (platform === "android" && configState.config.data.urlPlayStore) {
      window.open(configState.config.data.urlPlayStore);
    } else if (platform === "ios" && configState.config.data.urlAppStore) {
      window.open(configState.config.data.urlAppStore);
    }
  };

  const preguntarLuegoLocal = () => {
    hideModal()(modalDispatch);
  };

  return (
    <div className="ptur-versionApp-container">
      <div className="ptur-versionApp-header modalHeader">
        <span className="rb18m c-white">
          {textosState.textos.data?.nuevaVersion?.nombre}
        </span>
        {esCritico === false && (
          <div className="cruz" onClick={dissmiss}>
            <div className="cruzParte1"></div>
            <div className="cruzParte2"></div>
          </div>
        )}
      </div>
      <div className="ptur-versionApp-body modalBody">
        <span className="rb18m c-black">
          {textosState.textos.data?.nuevaVersion?.descripcion}
        </span>
        <div className="ptur-versionApp-btnCont">
          <button
            onClick={actualizarApp}
            className="ptur-versionApp-btn bgc-primary rb16m c-white"
          >
            Actualizar
          </button>
          {esCritico === false && (
            <button
              onClick={preguntarLuegoLocal}
              className="ptur-versionApp-btn bgc-latex30 rb16m c-white"
            >
              Preguntar más tarde
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default VersionApp;
